/** NOTE: (diwakersurya)This file is a copy of redux-api-v2 mainly because we wanted
 * to fix some options for making calls to grace service ( the ai service).
 * Another reason for copying was to get access to the
 * response object in baseRequest and handle partial-status code 206 holistically
 * at least for bff calls
 */
import type {Dispatch, ThunkAction} from 'src/reducers';

import {
  base,
  type RawQuery,
  type RequestOptions,
  type ApiPostOptions,
  type ApiOptions,
} from './redux-api';
import {ApiError, PartialError, captureApiError} from 'src/utils/errors';

import * as reduxApi from 'src/utils/redux-api-v2';


export type GraceApiOptions = {
  apiPath: string;
};

const graceOptions = {
  apiPath: '/grace/api/v1/',
} as const;

export const get = <ExpectedData = unknown>(
  path: string,
  query?: RawQuery,
  options?: ApiOptions,
): ThunkAction<any> =>
  baseRequest<ExpectedData>(path, {
    method: 'GET',
    query,
    options: {...options, ...graceOptions},
  });

export const post = <ExpectedData = unknown>(
  path: string,
  data?: Record<any, any>,
  query?: RawQuery,
  options?: ApiPostOptions,
): ThunkAction<any> =>
  baseRequest<ExpectedData>(path, {
    method: 'POST',
    data,
    query,
    options: {...options, ...graceOptions},
  });

export const patch = <ExpectedData = unknown>(
  path: string,
  data?: Record<any, any>,
  query?: RawQuery,
  options?: ApiPostOptions,
): ThunkAction<any> =>
  baseRequest<ExpectedData>(path, {
    method: 'PATCH',
    data,
    query,
    options: {...options, ...graceOptions},
  });

export const put = <ExpectedData = unknown>(
  path: string,
  data?: Record<any, any>,
  query?: RawQuery,
  options?: ApiPostOptions,
): ThunkAction<any> =>
  baseRequest<ExpectedData>(path, {
    method: 'PUT',
    data,
    query,
    options: {...options, ...graceOptions},
  });

export const del = <ExpectedData = unknown>(
  path: string,
  data?: Record<any, any>,
  options?: ApiOptions,
): ThunkAction<any> =>
  baseRequest<ExpectedData>(path, {
    method: 'DELETE',
    data,
    options: {...options, ...graceOptions},
  });

export const baseRequest =
  <ExpectedData = unknown>(
    path: string,
    options: RequestOptions,
  ): ThunkAction<ExpectedData> =>
  async (dispatch: Dispatch): Promise<ExpectedData> => {
    const response = await dispatch(base(path, options));
    const text = await response.text();
    let json: ExpectedData | string;
    if (response.headers.get('Content-Type') === 'application/json') {
      try {
        json = JSON.parse(text) as ExpectedData;
      } catch (error: any) {
        // NOTE (kyle): this should not happen.
        throw new ApiError({path, ...options}, response, text, error);
      }
    } else {
      json = text;
    }

    if (!response.ok) {
      throw new ApiError({path, ...options}, response, json);
    }
    //handle partial success responses
    if (response.status === 206) {
      throw new PartialError({path, ...options}, response, json);
    }

    return json as ExpectedData;
  };
